import { formatDateTime } from '../utils/format';

export default function FreshnessBadge({ label, asOf, status }) {
  const asOfLabel = asOf ? formatDateTime(asOf) : 'Unknown';
  const statusClass = status === 'stale' ? 'freshness-stale' : status === 'fresh' ? 'freshness-fresh' : 'freshness-unknown';

  const fresh = status === 'fresh';
  const text = fresh ? `${label} fresh` : `${label}: ${asOfLabel}${status === 'stale' ? ' (stale)' : ''}`;

  return (
    <span className={`freshness-badge ${statusClass}`} title={`${label}: ${asOfLabel}`}>
      {fresh ? (
        <svg className="freshness-check" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M3 8.2 6.2 11.5 13 4.5" />
        </svg>
      ) : null}
      {text}
    </span>
  );
}
